var site = site || {};
site.menu = site.menu || {};

/*
 Menu
 */
site.menu = {
	init: function () {
		$('form.meals-form').ajaxForm({
			dataType : 'json',
			success : function(responseText, statusText, xhr, $form) {
				var className = (responseText.success) ? 'success' : 'error';
				moya.message.growl(responseText.message, className);
			}
		});

		$('form.meals-form .add-line').click(function () {
			var $new = $('form.meals-form tbody tr:last').clone();
			var lastDate = new Date($new.find('textarea').data('timestamp'));
			var date = new Date(lastDate.getTime());
			date.setDate(date.getDate() + 1);
			var timestamp = date.getTime() / 1000;

			var month = date.getMonth()+1;
			month = (month < 10 ? '0' + month : month);

			$new.find('td.day').html(menu.meal.days[date.getDay()]);
			$new.find('td.full').html(("0" + date.getDate()).slice(-2) + '.' + month + '.' + date.getFullYear());
			$new.find('textarea')
				.attr('name', 'meal[' + timestamp + ']')
				.attr('id', 'meal-' + timestamp)
				.attr('data-timestamp', timestamp * 1000);

			$('form.meals-form tbody').append($new);

			return false;
		});

		menu.meal = {};
		menu.meal.days = {};
	}	
};